import React from 'react';
import {Button} from "antd";

const InteractBtn = ({showName = "打开", okName = "确定", status, toggleStatus, confirm}) => {
    const cancel = () => {
        toggleStatus(false);
    }

    const onOk = () => {
        confirm();
    }
    const show = () => {
        toggleStatus(true);
    }

    return (
        <>
            {!status ? <Button type={"primary"} onClick={show}>{showName}</Button> :
                <><Button style={{marginRight: 10}} onClick={cancel}>取消</Button>
                <Button type={"primary"} onClick={onOk}>{okName}</Button></>}
        </>
    )
}
export default InteractBtn;